import { useNewUserAccessRights } from '@app/hooks/useNewUserAccessRights';

export const useJournalAccessRights = () => {
  const {
    userAccessRights: {
      Records: {
        IsOn: hasUserRightForModuleView,
        IsCreate: hasUserRightToCreate,
        IsEdit: hasUserRightToEdit,
        IsDelete: hasUserRightToDelete,
        IsExport: hasUserRightToExport,
        IsJournal: hasUserRightToJournal,
        IsRegister: hasUserRightToRegister,
        IsStatuses: hasUserRightToChangeStatuses,
        IsViewPastRecords,
      },
    },
  } = useNewUserAccessRights();

  const canOnlyView: boolean = hasUserRightForModuleView && !hasUserRightToEdit;

  return {
    canOnlyView,
    hasUserRightToEdit,
    hasUserRightToCreate,
    hasUserRightToDelete,
    hasUserRightToExport,
    hasUserRightToJournal,
    hasUserRightToRegister,
    hasUserRightForModuleView,
    hasUserRightToChangeStatuses,
    IsViewPastRecords,
  };
};
